import { Fragment, useContext, useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";

import { Dialog, Transition } from "@headlessui/react";

import { ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FaTimes } from "components/atoms/Icon/fa/FaTimes";
import Img from "components/atoms/Img";
import { InputEmail, InputText } from "components/atoms/Input/index";

/** ========== */

const EbookModal = (props) => {
  /* Variables Define */

  const {
    show,
    onHide,
    imgLeft,
    imgRight,
    triggerName,
    contactFromId,
    apiLink,
    haveCheckBox,
    checkedId,
    unCheckId,
  } = props;

  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const recaptchaRef = useRef();
  const [checkImage] = useState(imgLeft || imgRight);
  const { openAlert } = useContext(ToastContext);

  /* Handle Event */
  const closeModal = () => {
    onHide();
    reset();
    clearErrors();
  };

  /* Effect */
  useEffect(() => {
    const getHash = window.location.hash || "";

    if (getHash.length > 0) {
      document.getElementById(getHash.replace("#", ""))?.click();
    }
  }, []);

  const onSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const newData = { ...data };

      newData.client_id = GAUserID ? GAUserID : "";
      newData.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      newData.contact_from_id = haveCheckBox
        ? data.contactFromId
          ? checkedId
          : unCheckId
        : contactFromId;

      document.getElementById("popup-content-panel").style.display = "none";

      sendData({
        api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/${apiLink}`,
        data: newData,
        token,
      })
        .then((res) => {
          if (res.state) {
            trigger("contact_form", data, triggerName);
            openAlert(3000, "success");
            setTimeout(() => {
              closeModal();
            }, 3000);
          } else {
            openAlert(3000, "error");
            document.getElementById("popup-content-panel").style.display =
              "block";
            console.log("error");
          }
        })
        .catch(() => {
          openAlert(3000, "error");
          document.getElementById("popup-content-panel").style.display =
            "block";
          console.log("error");
        });
    }
  };

  return (
    <>
      <Transition show={show} as={"div"}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModal}
          style={{ zIndex: 51 }}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-slate-900 bg-opacity-70" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                id="popup-content-panel"
                className={`relative inline-block w-full px-4 py-10 text-center ${
                  checkImage
                    ? "my-8 md:px-10 md:py-16 md:text-left"
                    : "max-w-[315px] "
                }  transform overflow-hidden rounded-2xl bg-white align-middle shadow-xl transition-all`}
                style={{ maxWidth: checkImage ? "920px" : "none" }}
              >
                <div
                  className={`absolute top-6 right-4  ${
                    checkImage ? "md:right-10" : ""
                  }`}
                >
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent text-sm font-medium text-bbc-gray outline-none transition-all focus:outline-none"
                    onClick={closeModal}
                  >
                    <FaTimes size={16} />
                  </button>
                </div>
                {/* <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  EbookModal
                </Dialog.Title> */}
                <div className="">
                  <div
                    className={`flex justify-between ${
                      imgLeft ? "flex-row" : ""
                    } ${imgRight ? "flex-row-reverse" : ""}`}
                  >
                    {checkImage && (
                      <div
                        className={`relative hidden w-1/2 md:block ${
                          imgLeft ? "mr-10" : ""
                        } ${imgRight ? "ml-10" : ""}`}
                      >
                        <Img
                          src={checkImage}
                          width={props.imgWidth || 310}
                          height={props.imgHeight || 445}
                          className={"w-full  "}
                          wrapper={{
                            className: ` w-full h-full  ${
                              imgLeft ? "border-r pr-10" : ""
                            } ${imgRight ? "border-l pl-10" : ""}`,
                          }}
                          alt="ebook background"
                        />
                      </div>
                    )}

                    <div
                      className={`w-full ${
                        checkImage
                          ? "items-center md:flex md:w-1/2"
                          : " md:w-full"
                      }`}
                    >
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-6 lg:mb-10">
                          <InputText
                            register={register}
                            errors={errors}
                            name="name"
                            placeholder="Name*"
                          />
                        </div>
                        <div className="mb-6 lg:mb-10">
                          <InputEmail register={register} errors={errors} />
                        </div>

                        {haveCheckBox && (
                          <label className=" mb-6 flex">
                            <input
                              type="checkbox"
                              {...register("contactFromId")}
                              className="bbc-checkbox mr-2 mt-1"
                            />
                            <span className="inline-block text-left text-sm">
                              I would like to receive more helpful insights into
                              offshore company incorporation.
                            </span>
                          </label>
                        )}

                        <ButtonNew
                          type="submit"
                          disabled={isSubmitting}
                          othersClass="relative"
                          style={{ width: 180 }}
                        >
                          {isSubmitting && (
                            <BiLoaderAlt
                              className="absolute mr-2 animate-spin"
                              size={24}
                            />
                          )}
                          Get It Free
                        </ButtonNew>
                        <em className="mt-6 block text-sm">
                          Document will be sent to your email shortly after
                          successful submission.
                        </em>
                        <div
                          className={`mt-6 flex justify-center ${
                            checkImage ? "md:justify-start" : ""
                          }`}
                        >
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={
                              process.env.NEXT_PUBLIC_G_RECAPTCHA_V3_SITE_KEY
                            }
                            badge="inline"
                            size="invisible"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default EbookModal;

EbookModal.propTypes = {};

EbookModal.defaultProps = {};

/** ========== */
